import React from 'react';
import { GlassCard } from "../ui/Card";

const AboutMeSection: React.FC = () => {
    return (
        <section id="about" className="section about-me-section reveal">
            <div className="container about-grid">
                <div className="about-text">
                    <h2 className="section-title text-left">Я — <strong>Карпенко Дарья</strong></h2>
                    <div className="about-content">
                        <p className="large-text">
                            Помогаю запускать цифровые продукты — от компактных MVP до масштабных систем.
                            Проектирую архитектуру так, чтобы продукт был готов к росту уже с первого дня.
                        </p>
                        <div className="highlight-box section-title">
                            <p>
                                Я работала с крупнейшими IT-компаниями и участвовала в развитии сервисов,
                                которыми ежедневно пользуются <strong>более 10 миллионов человек</strong>.
                            </p>
                        </div>
                        <p className="description-text">
                            Сегодня я применяю этот опыт, чтобы помогать стартапам и бизнесу запускать продукты быстро, надёжно и без лишних расходов.
                        </p>
                    </div>
                </div>
                <div className="about-stats">
                    <GlassCard>
                        <span className="stat-number">10M+</span>
                        <span className="stat-label">Ежедневная аудитория проектов</span>
                    </GlassCard>
                    <p>
                    </p>
                    <GlassCard>
                        <span className="stat-number">Senior</span>
                        <span className="stat-label">Уровень экспертизы</span>
                    </GlassCard>
                </div>
            </div>
        </section>
    );
};

export default AboutMeSection;
